import { ModalTranslationsModel } from "../Models/ModalTranslationsModel";
import { ModalTranslationTypes } from "../Models/ModalTranslationTypes";
import { WidgetNewslettersResultModel } from "../Models/WidgetNewslettersResultModel";
import { FollowParentResultModel } from "../Models/FollowParentResultModel";
import { AddOrUpdateSubmissionModel } from "../Models/AddOrUpdateSubmissionModel";
import { AddOrUpdateSubmissionResult } from "../Models/AddOrUpdateSubmissionResult";
import { IsSubmissionSubmitAllowedRequestModel } from "../Models/IsSubmissionSubmitAllowedRequestModel";
import { IsSubmissionSubmitAllowedResponseModel } from "../Models/IsSubmissionSubmitAllowedResponseModel";
import { ValidateSubmissionValueResult } from "../Models/ValidateSubmissionValueResult";
import { AddConversionModel } from "../Models/AddConversionModel";

export class DataService {
    public static subscribeToNewsletter(email: string, confirmedTerms: boolean, v2verifyToken: string, v3verifyToken: string, emptyField:string, blockName: string, newsletterOneId: string, newsletterTwoId: string, recaptchaVersion:number, callback: (output: WidgetNewslettersResultModel) => void, error?: () => void) {
        var formData = new FormData();
        formData.append("email", email);
        
        $.ajax({
            type: "POST",
            url: encodeURI(`/common/subscribetonewsletter?confirmedTerms=${confirmedTerms}&specialField=${emptyField}&blockName=${blockName}&newsletterOneId=${newsletterOneId}&newsletterTwoId=${newsletterTwoId}&recaptchaVersion=${recaptchaVersion}&v2verifyToken=${v2verifyToken}&v3verifyToken=${v3verifyToken}`),
            data: formData, // The form with the file inputs.
            success: callback,
            processData: false,
            contentType: false, 
            error: () => {
                error && error();
            }
        });
    }

    public static getModalTranslations(modalType: ModalTranslationTypes, callback: (output: ModalTranslationsModel) => void, error?: () => void) {
        $.ajax({
            type: "GET",
            url: encodeURI(`/common/getmodaltranslations?modalType=${modalType}`),
            success: callback,
            error: () => {
                error && error();
            }
        });
    }

    public static removeDiscussionItem(challengeId:string, discussionId: string, callback: (output: boolean) => void, error?: () => void) {
        $.ajax({
            type: "POST",
            url: encodeURI(`/challenge/${challengeId}/discussion/${discussionId}/remove`),
            success: callback,
            error: () => {
                error && error();
            }
        });
    }


    public static subscribeToParentForEmail(parentId, parentType, email, v2verifyToken, v3verifyToken, recaptchaVersion, callback: (output : FollowParentResultModel) => void, error?: () => void) {
        $.ajax({
            type: "POST",
            url: encodeURI(`/common/subscribetoparentforemail?parentId=${parentId}&parentType=${parentType}&email=${email}&recaptchaVersion=${recaptchaVersion}&v2VerifyToken=${v2verifyToken}&v3VerifyToken=${v3verifyToken}`),
            success: callback,
            error: () => {
                error && error();
            }
        });
    }

    public static subscribeToParentForUser(parentId, parentType, callback: (output: FollowParentResultModel) => void, error?: () => void) {
        $.ajax({
            type: "POST",
            url: encodeURI(`/common/subscribetoparentforuser?parentId=${parentId}&parentType=${parentType}`),
            success: callback,
            error: () => {
                error && error();
            }
        });
    }

    public static setDiscussionItemAsAnswered(challengeId:string, discussionId: string, callback: (output: boolean) => void, error?: () => void) {
        $.ajax({
            type: "POST",
            url: encodeURI(`/challenge/${challengeId}/discussion/${discussionId}/setasanswered`),
            success: callback,
            error: () => {
                error && error();
            }
        });
    }

    public static addOrUpdateSubmission(challengeId:string, uploadFormData: FormData, callback: (output: AddOrUpdateSubmissionResult) => void, error?: () => void) {
        $.ajax({
            type: "POST",
            url: encodeURI(`/challenge/${challengeId}/addorupdatesubmission`),
            success: callback,
            data: uploadFormData, // The form with the file inputs.
            processData: false,
            contentType: false, 
            error: () => {
                error && error();
            }
        });
    }

    public static deleteSubmissionFile(challengeId:string, data: FormData, callback: (output: AddOrUpdateSubmissionResult) => void, error?: () => void) {
        $.ajax({
            type: "POST",
            url: encodeURI(`/challenge/${challengeId}/deletesubmissionfile`),
            success: callback,
            data: data, // The form with the file inputs.
            processData: false,
            contentType: false, 
            error: () => {
                error && error();
            }
        });
    }

    public static isSubmissionSubmitAllowed(challengeId:string, model: IsSubmissionSubmitAllowedRequestModel, callback: (output: IsSubmissionSubmitAllowedResponseModel) => void, error?: () => void) {
        $.ajax({
            type: "POST",
            url: encodeURI(`/challenge/${challengeId}/issubmissionsubmitallowed`),
            success: callback,
            cache: false,
            contentType: "application/json",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            dataType: "json",
            data: JSON.stringify(model),
            error: () => {
                error && error();
            }
        });
    }

    public static isSubmissionValid(submissionId:string, callback: (output: boolean) => void, error?: () => void) {
        $.ajax({
            type: "POST",
            url: encodeURI(`/concept/${submissionId}/issubmissionvalid`),
            success: callback,
            cache: false,
            contentType: "application/json",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            dataType: "json",
            error: () => {
                error && error();
            }
        });
    }

    public static validateSubmissionValue(submissionId:string, itemId:string, callback: (output: ValidateSubmissionValueResult) => void, error?: () => void) {
        $.ajax({
            type: "GET",
            url: encodeURI(`/concept/${submissionId}/validate/${itemId}`),
            success: callback,
            cache: false,
            contentType: "application/json",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            dataType: "json",
            error: () => {
                error && error();
            }
        });
    }

    public static addConversion(conversion : AddConversionModel, callback: (output: boolean) => void, error?: () => void) {
        $.ajax({
            type: "POST",
            url: encodeURI(`/common/conversion/add`),
            success: callback,
            cache: false,
            contentType: "application/json",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            dataType: "json",
            data: JSON.stringify(conversion),
            error: () => {
                error && error();
            }
        });
    }
}